var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5737 15.3957L13.4354 11.2571C14.1385 10.1377 14.5466 8.81458 14.5466 7.39468C14.5466 3.37759 11.2901 0.121521 7.27316 0.121521C3.25622 0.121521 0 3.37759 0 7.39468C0 11.4119 3.25607 14.6677 7.27316 14.6677C8.81838 14.6677 10.2496 14.1846 11.4274 13.3637L15.5165 17.4531C15.8006 17.7369 16.1731 17.8783 16.5451 17.8783C16.9176 17.8783 17.2896 17.7369 17.5742 17.4531C18.142 16.8847 18.142 15.9639 17.5737 15.3957ZM7.27316 12.3113C4.55808 12.3113 2.35685 10.1102 2.35685 7.39499C2.35685 4.67975 4.55808 2.47853 7.27316 2.47853C9.9884 2.47853 12.1895 4.67975 12.1895 7.39499C12.1895 10.1102 9.9884 12.3113 7.27316 12.3113Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.538fcaa2.svg";
export { ForwardRef as ReactComponent };